<template>
  <div class="library_container">
    <div class="library_contnet">
      <!-- <div class="data_from flex">
        <div
          class="data_from_item data_from_item_znzc"
          :class="data_from == 'znzc' ? 'act' : ''"
          @click="changeData('znzc')"
        >
          <div class="icon_znzc"></div>
          <div class="data_from_item_text">智能座舱</div>
        </div>
        <div
          class="data_from_item data_from_item_znjs"
          :class="data_from == 'znjs' ? 'act' : ''"
          @click="changeData('znjs')"
        >
          <div class="icon_znjs"></div>
          <div class="data_from_item_text">智能驾驶</div>
        </div>
      </div> -->
      <div class="white_bg">
        <div
          class="filter_config_container"
          :style="{ height: is_show ? (data_from == 'znzc' ? '210px' :'165px') : '85px' }"
        >
          <template v-for="item in filterConditionRef" :key="item.field">
            <div class="config_item">
              <div class="config_label">{{ item.field }} :</div>
              <div class="config_list flex flex_wrap">
                <span
                  :class="[
                    !filterSelectedData[item.field].selectedText
                      ? 'current'
                      : '',
                  ]"
                  @click="changeFilterSelectedData(item.field, config, '')"
                  style="padding: 0 10px"
                  >不限</span
                >
                <span
                  :class="[
                    filterSelectedData[item.field].selectedText == config.text
                      ? 'current'
                      : '',
                  ]"
                  v-for="config of item.list"
                  :key="config.text"
                  @click="
                    changeFilterSelectedData(item.field, config, config.text)
                  "
                  >{{ config.text }}</span
                >
              </div>
            </div>
          </template>
        </div>
        <div class="show_or_hide" @click="is_show = !is_show">
            <div class="show_or_hide_btn">
              <div>
                {{ is_show ? "点击收起" : "展开更多" }}
              </div>
              <div class="icon_sanjiao" :class="is_show?'zhankai':'shouqi'"></div>
            </div>
        </div>
        <div
          class="filter_result_container"
          v-loading="data_loading"
          element-loading-text="数据加载中"
        >
          <div class="filter_tabs" v-if="filterTabRef && filterTabRef.length">
            <div class="level_one_tabs flex">
              <div
                class="one_tab"
                :class="ind == one_act_ind ? 'act' : ''"
                v-for="(item, ind) in filterTabRef"
                :key="ind"
                @click="tabOneChange(ind, item)"
              >
                {{ item.text }}
              </div>
            </div>
            <div
              class="level_two_tabs flex"
              v-if="
                !(
                  (filterTabRef[one_act_ind]['attr'].length == 1 &&
                    filterTabRef[one_act_ind]['attr'][0]['text'] ==
                      filterTabRef[one_act_ind]['text']) ||
                  !filterTabRef[one_act_ind]['attr'][0]['attr']
                )
              "
            >
              <div
                class="two_tab"
                :class="ind == two_act_ind ? 'act' : ''"
                v-for="(item, ind) in filterTabRef[one_act_ind]['attr']"
                :key="ind"
                @click="tabTwoChange(ind, item)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
          <el-table
            empty-text="暂无数据,敬请期待。"
            :data="carData"
            :cell-class-name="'center'"
            :header-row-class-name="'center table_header'"
            :row-class-name="tableRowBg"
            :border="true"
          >
            <el-table-column
              v-for="(item, ind) in attrs_arr"
              :key="ind"
              :label="item.text"
              :prop="item.field"
              width="auto"
            >
              <template #default="scope">
                {{ (scope && scope.row[item.field]) || "-" }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :total="count"
            :page-size="pageSize"
            v-model:currentPage="currentPage"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  // computed
} from "vue";
import { getCarFilterConfig, getCarLibrary } from "@/api";
import {
  getCarFilterConfig as getCarFilterConfig2,
  getCarLibrary as getCarLibrary2,
} from "@/api_drive";
import { ElTable, ElTableColumn, ElPagination } from "element-plus";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "Library",
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    //数据源
    const data_from = ref("znzc");
    //筛选项
    const filterConditionRef = ref([]);
    // 筛选项选中的数据
    const filterSelectedData = reactive({});
    //tab签th
    const filterTabRef = ref([]);
    console.log(route.path)
    if(route.path.indexOf('/drive')>-1){
      data_from.value = "znjs";
    }
    // const changeData = (from) => {
    //   one_act_ind.value = 0;
    //   two_act_ind.value = 0;
    //   data_from.value = from;
    //   getCarFilterConfigData();
    //   getCarData();
    // };

    const getCarFilterConfigData = () => {
      let promiseData =
        data_from.value == "znzc" ? getCarFilterConfig : getCarFilterConfig2;
      promiseData().then((res) => {
        if (res.code == 200) {
          const { condition, tab } = res.data;
          filterConditionRef.value = condition;
          filterTabRef.value = tab;
          attrs_arr.value =
            data_from.value == "znzc"
              ? tab[0]["attr"][0]["attr"]
              : tab[0]["attr"];
          for (let item of condition) {
            filterSelectedData[item.field] = {
              selectedText: "",
              params: {},
            };
          }
        }
      });
    };
    // 点击筛选项
    const changeFilterSelectedData = (type, data, selectedText) => {
      if (filterSelectedData[type].selectedText == selectedText) {
        return;
      }
      filterSelectedData[type].selectedText = selectedText;
      if (data) {
        filterSelectedData[type].params = data.params;
      } else {
        filterSelectedData[type].params = {};
      }
      currentPage.value = 1;
      count.value = 0;
      getCarData();
    };
    const handleTabClick = () => {};
    const count = ref(0),
      currentPage = ref(1),
      pageSize = ref(10),
      carData = ref([]);

    const data_loading = ref(false);

    const one_act_ind = ref(0);
    const two_act_ind = ref(0);
    const attrs_arr = ref([]);
    const tabOneChange = (ind, item) => {
      if (ind != one_act_ind.value) {
        one_act_ind.value = ind;
        two_act_ind.value = 0;
        attrs_arr.value =
          data_from.value == "znzc" ? item["attr"][0]["attr"] : item["attr"];
      }
    };
    const tabTwoChange = (ind, item) => {
      if (ind != two_act_ind.value) {
        two_act_ind.value = ind;
        attrs_arr.value = item["attr"];
      }
    };
    // 获取车型列表数据
    const getCarData = () => {
      data_loading.value = true;
      const data = {
        page: currentPage.value,
        rows: pageSize.value,
      };
      //重新请求list
      let params = {};
      for (let key in filterSelectedData) {
        Object.assign(params, filterSelectedData[key].params);
      }
      let promiseGet =
        data_from.value == "znzc" ? getCarLibrary : getCarLibrary2;
      promiseGet({
        ...data,
        ...params,
      }).then((res) => {
        if (res.code == 1) {
          count.value = res.data.count;
          const list = res.data.list;
          if (data.first_id && list[0] && list[0].id == data.first_id) {
            list[0].isWarning = true;
          }
          carData.value = list;
        }
        data_loading.value = false;
        // loading && loading.close()
      });
    };
    getCarFilterConfigData();
    getCarData();

    // 点击页数时
    const handlePageChange = () => {
      getCarData();
    };
    // table样式
    const tableRowBg = ({ rowIndex }) => {
      if (carData.value && carData.value[0].isWarning && rowIndex === 0) {
        return "warningBg";
      }
      return "";
    };

    const previewReport = (model_id) => {
      router.push({
        path: "/report/summary",
        query: {
          model_id,
        },
      });
    };

    const is_show = ref(false);

    return {
      data_from,
      // changeData,

      filterConditionRef,
      filterSelectedData,
      filterTabRef,

      count,
      currentPage,
      pageSize,
      carData,
      changeFilterSelectedData,
      handleTabClick,
      handlePageChange,
      previewReport,
      tableRowBg,
      is_show,
      data_loading,

      one_act_ind,
      tabOneChange,
      two_act_ind,
      tabTwoChange,
      attrs_arr,
    };
  },
};
</script>

<style scoped lang="less">
.library_container{
  width: 100%;
  height: 100%;
}
.library_contnet{
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
.white_bg {
  width: 1200px;
  margin: 0 auto;
  padding: 26px 0 63px;
  border-radius: 0px 13px 13px 13px;
  overflow-x: hidden;
}
.data_from {
  width: 1200px;
  margin: 50px auto 0;
  border-radius: 5px;
  display: flex;
  align-items: flex-end;
  .data_from_item {
    width: 260px;
    height: 67px;
    background: #abb9d6;
    font-size: 22px;
    color: #ffffff;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .icon_znzc {
      width: 40px;
      height: 40px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/znzc_.png)
        no-repeat center center;
      background-size: 27px;
    }
    .icon_znjs {
      width: 40px;
      height: 40px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/znjs_.png)
        no-repeat center center;
      background-size: 25px;
    }
    &.data_from_item_znzc {
      border-radius: 8px 0px 0px 0px;
    }
    &.data_from_item_znjs {
      border-radius: 0px 8px 0px 0px;
    }
    .data_from_item_text {
      padding: 0 10px;
    }
    &.act {
      width: 282px;
      height: 73px;
      background: #ffffff;
      font-size: 22px;
      font-weight: bold;
      color: #0b0b0b;
      padding-top: 9px;
      border-radius: 8px 8px 0px 0px;
      .icon_znzc {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/znzc_act.png)
          no-repeat center center;
        background-size: 27px;
      }
      .icon_znjs {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/znjs_act.png)
          no-repeat center center;
        background-size: 25px;
      }
    }
  }
}
.filter_config_container {
  // width: 1090px;
  width: 1360px;
  font-size: 14px;
  color: #474747;
  padding: 0 50px 0;
  height: auto;
  transition: height 500ms;
  position: relative;
  overflow: hidden;
  .config_item {
    line-height: 32px;
  }
  .config_label {
    float: left;
    margin: 5px 0;
    color: #474747;
    font-weight: bold;
  }
  .config_list {
    margin-left: 62px;
    span {
      margin: 8px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      padding: 0 3px;
      white-space: nowrap;
      cursor: pointer;
     
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background: #ebefff;
        color: #474747;
      }
       &.current {
        background: #1FBCBF;
        color: #fff;
      }
    }
  }
}
.report_compare_btn {
  position: fixed;
  padding-top: 31px;
  bottom: 50px;
  right: 0;
  z-index: 1000;
  width: 230px;
  padding: 20px 10px 20px 20px;
  background: #fff;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.05);
  // background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/f557a5eabbb9c64e539d530a19d764a9.png) no-repeat top center;
  // background-size: 100%;
  font-size: 16px;
  color: #000;
  .car_num {
    text-align: center;
    color: #787878;
    font-size: 14px;
    margin: 15px 0 10px 0;
  }
  .to_page_btn {
    display: block;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
    font-weight: bold;
    border: 1px solid #787878;
    width: 60%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    outline: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
  }
  .contrast_item {
    height: 46px;
    font-size: 14px;
    line-height: 1.2;
    background-color: #f9f9f9;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 0 10px;
  }
}
.filter_result_container {
  padding: 0 50px;
  margin-top: 30px;
  width: auto;
  min-width: 1090px;
  max-width: 1600px;
  overflow: hidden;
}
.report_btn {
  padding: 20px 0;
  cursor: pointer;
  img {
    width: 18px;
    height: 20px;
  }
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
:deep(.el-tabs__nav-wrap::after) {
  display: none;
}
:deep(.el-tabs__item) {
  height: 45px;
  font-size: 15px;
  // &.is-active, &:hover{
  //   font-weight: bold;
  //   color: #00CDFF;
  // }
}
:deep(.el-tabs__active-bar) {
  height: 3px;
  // background: #00CDFF;
  border-radius: 1px;
}
:deep(.center .cell) {
  text-align: center;
  color: #474747;
  line-height: 20px;
}

:deep(.table_header th) {
  background: #f5f7f9;
  font-weight: bold;
}
// .#F5F8FF{
//   background: #F5F8FF;
// }
:deep(.el-pagination) {
  margin-top: 40px;
  text-align: center;
  .btn-prev,
  .btn-next {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.show_or_hide {
  width: 1210px;
  height: 29px;
  margin: 0 0 0 -5px;
  border-radius:0 0 20px 20px;
  border-bottom: solid 1px #dee8f6;
  background: #fff;
  position: relative;
  .show_or_hide_btn{
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #969696;
    background: #fff;
    .icon_sanjiao{
      width: 10px;
      height: 10px;
      margin-left: 7px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zksq_sanjiao.png) no-repeat center center;
      background-size: 8px;
      transition: all 500ms;
      &.shouqi{
        transform: rotateZ(180deg);
      }
    }
  }
}

:deep(.warningBg) {
  // background-color: #E6A23C !important;
  background-color: #fce6c6 !important;
}

.filter_tabs {
  margin-bottom: 36px;
  .level_one_tabs {
    .one_tab {
      padding: 12px 13px;
      margin-right: 15px;
      font-weight: 400;
      font-size: 16px;
      color: #474747;
      cursor: pointer;
      &.act {
        font-weight: 500;
        border-bottom: solid 3px #1FBCBF;
      }
    }
  }
  .level_two_tabs {
    min-height: 30px;
    padding: 5px 0 5px 34px;
    background: #f5f8fc;
    flex-wrap: wrap;
    .two_tab {
      padding: 10px 0;
      margin: 0 35px 0 0;
      font-size: 14px;
      color: #474747;
      font-weight: 400;
      cursor: pointer;
      &.act {
        font-weight: 500;
        color: #1FBCBF;
      }
    }
  }
}
</style>
<style>
::-webkit-scrollbar{
    height: 10px;
}
</style>